import React from "react";
import styled from "styled-components";

// Standalone auth pages land users on /users/communities after login, which
// bounces to /communities via a Rails redirect. Kept separately for Login
// vs. Register so each button surfaces the right action.
const LOGIN_URL = "/login?redirect_after_login=%2Fusers%2Fcommunities";
const REGISTER_URL = "/signup?redirect_after_login=%2Fusers%2Fcommunities";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`;

const Card = styled.div`
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  max-width: 400px;
  width: calc(100% - 2rem);
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
`;

const Logo = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), #ffb347);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;

  span {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
  }
`;

const Title = styled.h2`
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--foreground);
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  font-size: 0.9375rem;
  color: var(--muted-foreground);
  line-height: 1.5;
  margin-bottom: 1.75rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;
`;

const LoginLink = styled.a`
  flex: 1;
  padding: 0.625rem 1.25rem;
  border-radius: 9999px;
  background: var(--primary);
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
  text-align: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.88;
    color: white;
    text-decoration: none;
  }
`;

const RegisterLink = styled.a`
  flex: 1;
  padding: 0.625rem 1.25rem;
  border-radius: 9999px;
  background: transparent;
  color: var(--primary);
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
  text-align: center;
  border: 1.5px solid var(--primary);
  transition: all 0.2s;

  &:hover {
    background: rgba(var(--primary-rgb), 0.08);
    text-decoration: none;
  }
`;

const AuthOverlay = () => (
  <Overlay>
    <Card>
      <Logo>
        <span>T</span>
      </Logo>
      <Title>Gabung Taxsam Community</Title>
      <Subtitle>
        Login atau daftar untuk berdiskusi, berbagi wawasan, dan terhubung
        dengan sesama profesional pajak.
      </Subtitle>
      <ButtonRow>
        <LoginLink href={LOGIN_URL}>Masuk</LoginLink>
        <RegisterLink href={REGISTER_URL}>Daftar</RegisterLink>
      </ButtonRow>
    </Card>
  </Overlay>
);

export default AuthOverlay;
